var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSkylight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/hazard/skylight") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/hazard/skylight",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.4435545,80.5924563 L59.1430898,80.5924563 L59.1430898,61.7416405 C59.1430898,60.7619363 58.3488762,59.9677227 57.369172,59.9677227 L42.6305015,59.9677227 C41.6507972,59.9677227 40.8552774,60.7619363 40.8552774,61.7416405 L40.8552774,80.5924563 L27.556119,80.5924563 L27.556119,45.4746314 L49.9991836,23.032873 L53.1695065,26.2018897 L53.1472999,26.2254026 L55.1014832,28.179586 L57.6108324,25.695056 L72.4971116,40.5813353 L70.0112754,43.0436586 L72.4435545,45.4759377 L72.4435545,80.5924563 Z M44.7740943,80.5415117 L55.2242728,80.5415117 L55.2242728,63.8865397 L44.7740943,63.8865397 L44.7740943,80.5415117 Z M86.0653622,50.0661786 L76.5112865,40.5107966 L78.8416763,38.1804068 L76.8874929,36.2262234 L74.5571031,38.5566132 L59.6394733,23.6402897 L61.8745052,21.4052577 L59.9203218,19.4510744 L57.6852899,21.6861063 L49.9991836,14 L13.9356175,50.0661786 C12.6881275,51.3123624 12.6881275,53.3344719 13.9356175,54.5806557 C15.1818013,55.829452 17.2039109,55.829452 18.4500947,54.5806557 L21.1697536,51.8609967 L21.1697536,86.0435306 L78.8299198,86.0435306 L78.8299198,51.8609967 L81.5495788,54.5806557 C82.1713644,55.2050539 82.9890909,55.5159467 83.8068173,55.5159467 C84.6232375,55.5159467 85.440964,55.2050539 86.0653622,54.5806557 C87.3115459,53.3344719 87.3115459,51.3123624 86.0653622,50.0661786 L86.0653622,50.0661786 Z",
    id: "skylight",
    fill: "#1C7B97"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkylight);
export default __webpack_public_path__ + "static/media/skylight.f66c4148.svg";
export { ForwardRef as ReactComponent };